export const TRANSLATION_KEYS = {
    NoticeCalloutHeading: "homepage.noticeSectionHeading",
    NoticeEmpty: "homepage.noticeEmpty"
};